import * as types from './types';

const allIds = (state = [], action) => {
  switch (action.type) {
    case types.RECEIVE_ENTITIES: {
      return action.entities.map(entity => entity.id);
    }
    case types.ADD_ENTITY: {
      return [...state, action.entity.id];
    }
    case types.REMOVE_ENTITY: {
      return state.filter(id => id !== action.id);
    }
    default: return state;
  }
};

export default allIds;

export const getIds = state => state;
